import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    androidScreenMarginBottom,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    description: {
        marginTop: 16,
        lineHeight: 24,
        width: widthPercentageToDP(328, 480, 480),
    },
    button: {
        width: isTabletOrWeb ? 120 : widthPercentageToDP(328),
        paddingHorizontal: 18,
    },
    buttonText: {
        color: COLOR.background,
    },
    container: {
        marginBottom: androidScreenMarginBottom,
    },
});

export default styles;
